export default {
  en: {
    contact: 'Contact',
    here_for_you: 'We are here for you',
  },
  de: {
    contact: 'Kontakt',
    here_for_you: 'Wir sind für Dich da',
  },
};
